var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { docReady } from '../utils/docReady';
const typeNames = {
    'product': 'Products',
    'page': 'Pages',
    'article': 'Journal Articles',
    'collection': 'Collections',
    'treatments': 'Treatments'
};
class LiveSearch {
    constructor(container) {
        this.shouldRedirect = undefined;
        this.resultsCount = 0;
        this.resultsLimit = 5;
        this.isEmpty = false;
        this.hasClosed = false;
        this.searchContainer = container;
        this.searchInput = this.searchContainer.querySelector('.burger-menu__search-field');
        this.searchButton = this.searchContainer.querySelector('.burger-menu__search-button');
        this.liveSearch = this.searchContainer.querySelector('.burger-menu__search-live');
        this.seeAllButton = this.searchContainer.querySelector('.burger-menu__search-live-button');
        this.liveSearchContainer = this.searchContainer.querySelector('.burger-menu__search-live-container');
        this.liveSearchResults = this.searchContainer.querySelector('.burger-menu__search-live-results');
        this.liveSearchCount = this.searchContainer.querySelector('.burger-menu__search-live-results__count');
        this.liveSearchTotal = this.searchContainer.querySelector('.burger-menu__search-live-results__total');
        this.resultsLimit = parseInt(this.liveSearch.dataset.resultsLimit);
        this.initEventListeners();
        let currValue = this.searchInput.value;
        if (currValue.length > 0) {
            setTimeout(() => {
                this.getResults(currValue);
            }, 1000);
        }
    }
    getResults(searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let response = yield fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article,collection&resources[limit]=${this.resultsLimit}`);
                let responsePages = yield fetch(`/search?q=${searchTerm}&view=json`);
                let data = yield response.json();
                let dataPages = yield responsePages.json();
                let results = data.resources.results;
                results.pages = [];
                results.treatments = [];
                dataPages.results.map((result) => {
                    if (result.isTreatment == 'true') {
                        results.treatments.push(result);
                    }
                    else if (result.type == 'page') {
                        results.pages.push(result);
                    }
                });
                let total = Object.keys(results).reduce((acc, key) => acc + results[key].length, 0);
                this.liveSearchContainer.innerHTML = '';
                this.resultsCount = total;
                if (total == 0)
                    return resolve(false);
                ['products', 'collections', 'pages', 'treatments', 'articles'].map((type) => {
                    let searchResults = results[type];
                    if (!searchResults || searchResults.length == 0)
                        return;
                    let typeEl = document.createElement('div');
                    typeEl.classList.add('burger-menu__search-live__result-type');
                    typeEl.innerHTML = type;
                    this.liveSearchContainer.appendChild(typeEl);
                    searchResults.map((result, i) => {
                        let searchResultEl = document.createElement('a');
                        searchResultEl.classList.add('burger-menu__search-live__result');
                        searchResultEl.setAttribute('href', result.url);
                        searchResultEl.innerHTML = `
                      <div class="burger-menu__search-live__result-text">
                        <div class="burger-menu__search-live__result__title">${result.title}</div>
                      </div>
                  `;
                        //  <div class="burger-menu__search-live__result__description">${result.description}</div>
                        this.liveSearchContainer.appendChild(searchResultEl);
                    });
                });
                resolve(this.resultsCount > 0);
            }));
        });
    }
    updateLiveSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            let currValue = this.searchInput.value;
            let resultsFound = yield this.getResults(currValue);
            debugger;
            if (currValue.length > 0 && resultsFound && !this.hasClosed) {
                this.liveSearch.classList.add('burger-menu__search-live--active');
            }
            else {
                this.liveSearch.classList.remove('burger-menu__search-live--active');
            }
        });
    }
    ;
    initEventListeners() {
        this.searchInput.addEventListener('keyup', (event) => {
            let currValue = this.searchInput.value;
            this.isEmpty = currValue.length == 0;
            let redirectFound = window.searchRedirects.find((redirect) => {
                return redirect.searchTerm.toLowerCase() === currValue.toLowerCase();
            });
            if (redirectFound) {
                this.shouldRedirect = redirectFound.redirectTarget;
            }
            else {
                this.shouldRedirect = undefined;
            }
            if (this.searchTimeout)
                clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.updateLiveSearch();
            }, 100);
        });
        document.addEventListener('click', (event) => {
            if (!this.liveSearch.contains(event.target) && !this.searchInput.contains(event.target) && this.liveSearch.classList.contains('burger-menu__search-live--active')) {
                this.liveSearch.classList.remove('burger-menu__search-live--active');
                this.hasClosed = true;
            }
        });
        this.searchInput.addEventListener('focus', (event) => {
            if (!this.isEmpty && this.resultsCount > 0) {
                this.liveSearch.classList.add('burger-menu__search-live--active');
            }
        });
        this.searchButton.addEventListener('click', this.goToResults.bind(this));
        this.seeAllButton.addEventListener('mousedown', this.goToResults.bind(this));
    }
    goToResults() {
        if (this.shouldRedirect) {
            window.location.href = this.shouldRedirect;
        }
        else {
            window.location.href = '/search/?q=' + this.searchInput.value;
        }
    }
}
docReady(() => {
    const searchContainer = document.querySelector('.burger-menu__search');
    const liveSearch = new LiveSearch(searchContainer);
});
